'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyImg = undefined;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactLazyload = require('react-lazyload');

var _reactLazyload2 = _interopRequireDefault(_reactLazyload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_OFFSET = 300;
var LazyImg = function LazyImg(_ref /*: {offset?: number} */) {
  var _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? DEFAULT_OFFSET : _ref$offset,
      props = _objectWithoutProperties(_ref, ['offset']);

  return typeof window === 'undefined' ? React.createElement('img', props) : React.createElement(
    _reactLazyload2.default,
    { once: true, offset: offset, height: props /*: any */.height },
    React.createElement('img', props)
  );
};

exports.LazyImg = LazyImg;
LazyImg.displayName = 'LazyImg';


//////////////////
// WEBPACK FOOTER
// ../tutellus-ui/lib/LazyImg.js
// module id = 38
// module chunks = 0